
<div class="ksk-modal-swap" *ngIf="isSwapMode">
    <h1       
        [ngStyle]="
        styleService.getStyleRule([
        tab.configurations?.swapOfferCms?.selectTitleConfig,
        undefined,
        'mainText'
        ])
    ">{{ getSwapHeaderText | conditionalUppercase : styleService.getUppercaseValue(getSwapHeaderStyle?.text) }}</h1>

    <carousel-list [showControls]="true" [itemsPerPage]="itemsPerPage">
        <ng-container *ngFor="let slide of swapItemsList">
            <ng-container *carouselItem>
            <div [ngClass]="'card-list-' + itemsPerPage">
              <div
                *ngFor="let card of slide"
                [ngClass]="{
                    'card-selected': card.isSelected,
                    'card-notselected': !card.isSelected
                }"
                [ngStyle]="
                    card.isSelected
                    ? styleService.getStyleRule(undefined, undefined, [
                        tab.configurations.swapOfferCms?.activeImageBorder
                    ])
                    : styleService.getStyleRule(undefined, undefined, [
                        tab.configurations.swapOfferCms?.inactiveImageBorder
                    ])
                "
                >
                <app-choose-reward-card
                    [tab]="tab"
                    [campaign]="card"
                    (click)="chooseOffer(card)"
                ></app-choose-reward-card>
                </div>
            </div>
            </ng-container>
        </ng-container>
    </carousel-list>
    <button
      class="swap-btn"
      [ngClass]="isNotChosenAnyReward() ? 'disabled': ''"
      [ngStyle]="
        styleService.getStyleRule(
          [getSwapBackContinue?.text],
          [
            isNotChosenAnyReward()
              ? getSwapBackContinueDisabled?.background
              : getSwapBackContinue?.background
          ],
          [
            isNotChosenAnyReward()
              ? getSwapBackContinueDisabled?.border
              : getSwapBackContinue?.border
          ]
        )
      "
      (click)="confirmSwap()"
      [disabled]="isNotChosenAnyReward()"
    >
      {{
        tab.configurations.swapOfferCms?.buttonContinue
          ? (tab.configurations.swapOfferCms?.buttonContinue
            | conditionalUppercase
              : styleService.getUppercaseValue(
                  tab.configurations.swapOfferCms?.buttonContinueConfig.text
                ))
          : "Continue"
      }}
    </button>
    <button 
        class="swap-btn"
        (click)="exitSwapMode()"
        [ngStyle]="
            styleService.getStyleRule(
            [getSwapBackStyle?.text],
            [getSwapBackStyle?.background],
            [getSwapBackStyle?.border]
        )"
    >{{ getSwapBack | conditionalUppercase
                    : styleService.getUppercaseValue(getSwapBackStyle?.text) }}</button>
</div>